import * as React from 'react';

import './ConfigurationDownload3D.scss';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { requestAPIActions } from 'loopback-react-request';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationDownload3D.messages';

export interface ConfigurationDownload3DProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
	threeCanvasRef: any
}

export interface ConfigurationDownload3DState {
}

export class ConfigurationDownload3DPartial extends React.Component<ConfigurationDownload3DProps, ConfigurationDownload3DState> {
  constructor(props: ConfigurationDownload3DProps) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps: ConfigurationDownload3DProps) {
  }

	captureImage = () => {
    const threeJsEl = document.getElementById('threejs');
    if (!threeJsEl) return;
    const threeJsCanvas = threeJsEl.querySelector('canvas');
    if (!threeJsCanvas) return;

    // Create a second canvas for the overlay
    const overlayCanvas = document.createElement('canvas');
    overlayCanvas.width = threeJsCanvas.width;
    overlayCanvas.height = threeJsCanvas.height;
    const overlayCtx = overlayCanvas.getContext('2d');

    if (!overlayCtx) {
      console.error('Failed to create 2D context for overlay.');
      return;
    }

    // Draw the Three.js canvas onto the overlay canvas
    overlayCtx.drawImage(threeJsCanvas, 0, 0);

    // Load and draw the overlay image
    const overlayImage = new Image();
		const surfaceColor = (this.configuration && this.configuration.surface && this.configuration.surface.color) || (this.configuration && this.configuration.defaults  && this.configuration.defaults.surface.color.default) || 'white';
    const color = surfaceColor === 'white' ? 'light' : 'dark';
    console.log('color', color);
		overlayImage.src = `/img/logo-watermark-${color}.svg`;
    overlayImage.onload = () => {
      if (!this.configuration || !this.configuration.selectedTrough) return;
      const canvasWidth = overlayCanvas.width;
      const canvasHeight = overlayCanvas.height;

      // Calculate dimensions for the overlay image
      const overlayWidth = canvasWidth * 0.3; // 30% of the canvas width
      const overlayHeight = overlayImage.height * (overlayWidth / overlayImage.width); // Keep the aspect ratio
      const overlayX = (canvasWidth - overlayWidth) / 2; // Center horizontally
      const overlayY = (canvasHeight - overlayHeight) / 2; // Center vertically

      // Draw the overlay image
      overlayCtx.drawImage(overlayImage, overlayX, overlayY, overlayWidth, overlayHeight);

      // Generate the combined image
      const dataUrl = overlayCanvas.toDataURL();

      // Create a link for download
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `${this.configuration.sapNumber}-${this.configuration.selectedTrough.trough.fileName}.png`;

      // Trigger the download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    overlayImage.onerror = () => {
      console.error('Failed to load overlay image.');
    };
  };

  public render() {
		if (this.show2d || !this.configuration || !this.configuration.selectedTrough) { return <></>; }

    return (
      <div className="partial-configuration-capture-3d">
				<button className="btn btn-light btn-bordered" onClick={this.captureImage}>
        	<FormattedMessage {...MESSAGES.configurationDownload3D} />
				</button>
      </div>
    );
  }

  private get configuration(): ConfigurationModel | undefined {
    const {
      configuration,
    } = this.props;
    return configuration && configuration.result;
  }

  private get show2d(): boolean { 
    if (!this.configuration) {
      return false;
    }
    return this.configuration.show2d;
  }
}

export const ConfigurationDownload3D = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration
}))(ConfigurationDownload3DPartial);

export default ConfigurationDownload3D;
